export default {
  BRANCH_IO_PRODUCTION_WEB: 'key_live_joZlnhZ6Z914N8eYBdj7NiphFBiJH7w1',
  BRANCH_IO_DEVELOPMENT_WEB: 'key_test_peWmgg24519WS2fWEnCf9ggivFaHQ3Pi'
};
